// extracted by mini-css-extract-plugin
module.exports = {"TechCardClass":"TechCard_TechCardClass__1_w6k"};